import {
  CalendarDays,
  ClipboardList,
  Database,
  MessageSquare,
  Phone,
  UserRoundCog,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { EMPLOYEE_NAV_CHILDREN } from './employeeNav';
import { TASK_NAV_CHILDREN } from './taskNav';

export type LeafItem = {
  kind: 'leaf';
  to: string;
  label: string;
  Icon: LucideIcon;
};

export type GroupItem = {
  kind: 'group';
  id: string;
  label: string;
  Icon: LucideIcon;
  children: { to: string; label: string }[];
};

export type NavItem = LeafItem | GroupItem;

export const PRIMARY_NAV_ITEMS: NavItem[] = [
  { kind: 'leaf', to: '/chat', label: 'Chat', Icon: MessageSquare },
  { kind: 'leaf', to: '/calls', label: 'Calls', Icon: Phone },
  {
    kind: 'group',
    id: 'task-management',
    label: 'Task Management',
    Icon: ClipboardList,
    children: TASK_NAV_CHILDREN.map(({ to, label }) => ({ to, label })),
  },
  {
    kind: 'group',
    id: 'employee-hub',
    label: 'Employee Hub',
    Icon: UserRoundCog,
    children: EMPLOYEE_NAV_CHILDREN.map(({ to, label }) => ({ to, label })),
  },
  { kind: 'leaf', to: '/calendar', label: 'Calendar', Icon: CalendarDays },
  { kind: 'leaf', to: '/dbms', label: 'DBMS', Icon: Database },
];
